// GOOGLE example : http://scrollsample.appspot.com/items

import {tooltip} from "./bootstrap-tooltip";
import {favoris} from "../modules/03-components";

var next_page;
var prev_page;
var lastPage;
var last_scroll = 0;
var is_loading = 0; // simple lock to prevent loading when loading


function loadFollowing() {

    console.log('loadFollowing ' + next_page);

    $('.pagination').hide();

    is_loading = 1;
    $.ajax({
        url: $('#vehicule_list').data('url'),
        data: $('#recherche').serialize() + '&page=' + next_page
    }).done(function(data ) {
        $('#vehicule_list').append(data.liste);
        favoris();
        tooltip();
        next_page++;
        is_loading = 0;
    });
}

function loadPrevious() {

    console.log('loadPrevious ' + prev_page);

    is_loading = 1;
    $.ajax({
        url: $('#vehicule_list').data('url'),
        data: $('#recherche').serialize() + '&page=' + prev_page
    }).done(function(data ) {
        $('#vehicule_list').prepend(data.liste);

        item_height = $(".listitempage:first").height();
        window.scrollTo(0, $(window).scrollTop()+item_height); // adjust scroll

        favoris();
        tooltip();

        prev_page--;
        is_loading = 0;
    });
}

function mostlyVisible(element) {
    // if ca 25% of element is visible
    var scroll_pos = $(window).scrollTop();
    var window_height = $(window).height();
    var el_top = $(element).offset().top;
    var el_height = $(element).height();
    var el_bottom = el_top + el_height;

    return ((el_bottom - el_height*0.25 > scroll_pos) &&
        (el_top < (scroll_pos+0.5*window_height)));
}

function initPaginator() {
    next_page = parseInt($('#vehicule_list').data('page')) + 1;
    prev_page = next_page - 2;
    lastPage = parseInt($('#vehicule_list').data('lastpage'));

    $(window).scroll(function () {
        // handle scroll events to update content
        var scroll_pos = $(window).scrollTop();
        if (scroll_pos >= 0.6 * ($(document).height() - $(window).height())) {
            if (is_loading === 0 && next_page <= lastPage) loadFollowing();
        }
        if (scroll_pos <= 0.6 * $("#header").height()) {
            if (is_loading === 0 && prev_page >= 1) loadPrevious();

        }
        // Adjust the URL based on the top item shown
        // for reasonable amounts of items
        if (Math.abs(scroll_pos - last_scroll) > $(window).height() * 0.5) {
            last_scroll = scroll_pos;
            $(".listitempage").each(function(index) {
                if (mostlyVisible(this)) {
                    history.replaceState(null, null, $(this).attr("data-url"));
                    return false;
                }
            });
        }
    });

}


initPaginator();
